import { toast } from 'react-toastify';
import { Box, Typography } from '@mui/material';
import { startCase } from 'lodash';
import InfoIcon from '@mui/icons-material/PriorityHigh';
import ErrorIcon from '@mui/icons-material/Clear';
import SuccessIcon from '@mui/icons-material/Check';
import { TimelyToastContainer } from './TimelyToastContainer';

export const TimelyToast = {
  success: (message?: string, title?: string) => {
    TimelyToastGenerator('success', message, title);
  },
  info: (message: string, title?: string) => {
    TimelyToastGenerator('info', message, title);
  },
  warning: (message: string, title?: string) => {
    TimelyToastGenerator('warning', message, title);
  },
  error: (message: string, title?: string) => {
    TimelyToastGenerator('error', message, title);
  }
};

const ToastContainer = (props: any) => <div>{props.children}</div>;

const TimelyToastGenerator = (
  type: 'success' | 'error' | 'info' | 'warning',
  message?: string,
  title?: string
) => {
  const icon = {
    success: <SuccessIcon style={{ color: 'white', fontSize: 14 }} />,
    info: <InfoIcon style={{ color: 'white', fontSize: 14 }} />,
    warning: <InfoIcon style={{ color: 'white', fontSize: 14 }} />,
    error: <ErrorIcon style={{ color: 'white', fontSize: 14 }} />
  };

  const iconBg = {
    success: '#5B9E28',
    info: '#3DABF5',
    warning: '#F2AE49',
    error: '#E24C4C'
  };

  if (title || message) {
    const content = (
      <ToastContainer>
        <Box display="flex" flexDirection="row" width="100%">
          <Box
            width={20}
            height={20}
            borderRadius="50%"
            bgcolor={iconBg[type]}
            marginRight={1.4}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexShrink={0}
            marginTop={0.2}
          >
            {icon[type]}
          </Box>
          <Box>
            <Typography
              variant="body1"
              color="textPrimary"
              style={{ fontWeight: 600, marginBottom: 4 }}
            >
              {!title ? startCase(type) : title}
            </Typography>
            {message ? message : null}
          </Box>
        </Box>
      </ToastContainer>
    );

    // calling type based toast -> toast.error(message)
    toast[type](content);
  }
};

export const renderInvalidForm = () => {
  TimelyToast.error('Please answer all questions', 'Invalid');
};

export { TimelyToastContainer };
